/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name ExclamationMark
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjI1IDR2MTEuMjg0YS43NS43NSAwIDAwMS41IDBWNGEuNzUuNzUgMCAwMC0xLjUgME0xMiAyMWExLjUgMS41IDAgMTAwLTMgMS41IDEuNSAwIDAwMCAzIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=) - https://fondue-components.frontify.com/?path=/story/icons-icons--default&args=iconName:exclamation-mark
 * @see https://fondue-components.frontify.com/?path=/story/icons-icons--default - Documentation
 */
export const IconExclamationMark = createFondueIcon('ExclamationMark', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M11.25 4v11.284a.75.75 0 001.5 0V4a.75.75 0 00-1.5 0M12 21a1.5 1.5 0 100-3 1.5 1.5 0 000 3","clip-rule":"evenodd"}]]);
